/**
 * Capitalizes first letter of a word, in case CSS isnt' used or isn't working for some reason.
 *
 * @param {*} [first, ...rest]
 * @param {string} [locale=navigator?.language || 'hr-HR']
 */
const capitalizeFirstLetter = (
    [first, ...rest] = "",
    locale = (typeof window !== "undefined" &&
        typeof navigator !== "undefined" &&
        navigator?.language) ||
        "hr-HR",
) => `${first ? first.toLocaleUpperCase(locale) : ""}${rest ? rest.join("") : ""}`;

export { capitalizeFirstLetter };
